import { render, staticRenderFns } from "./ProductType.vue?vue&type=template&id=53b0da72&scoped=true"
import script from "./ProductType.vue?vue&type=script&lang=js"
export * from "./ProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_9d3e8444ee7ad6f099877d142dfca7ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b0da72",
  null
  
)

export default component.exports